<template>
  <div :class="{ 'd-inline-flex align-middle mr-2': !botaoDropdown }">
    <template v-if="tipoBotao === 'texto'">
      <button
        type="button"
        class="btn btn-sm btn-primary font-weight-bold"
        @click.prevent="abrir"
      >
        <i class="fas fa-users"></i>Usuários
      </button>
    </template>
    <template v-else-if="tipoBotao == 'icone'">
      <b-button
        :variant="variant"
        size="sm"
        class="btn-icon"
        v-b-tooltip.noninteractive
        title="Usuários"
        @click="abrir"
      >
        <i class="fas fa-users"></i>
      </b-button>
    </template>
    <template v-else-if="tipoBotao === 'dropdown'">
      <b-dropdown-item @click.prevent="abrir">Usuários</b-dropdown-item>
    </template>

    <b-modal
      ref="mdlUsuariosConta"
      title="Usuários da Conta"
      scrollable
      size="xl"
      ignore-enforce-focus-selector=".swal2-container"
      no-close-on-esc
      no-close-on-backdrop
      content-class="config-modal-content"
      body-class="px-0 pb-2 pt-0"
      header-class="config-modal-header border-0"
      footer-class="config-modal-footer"
    >
      <b-tabs
        v-model="abaSelecionada"
        content-class="p-4"
        lazy
        nav-wrapper-class="sticky-top bg-white"
        nav-class="config-tabs-nav"
      >
        <b-tab title="Comunicante" active>
          <tab-usuarios-comunicante
            :conta="conta"
            ref="abaUsuariosComunicante"
            @erro-permissao="fecharPorErro"
          ></tab-usuarios-comunicante>
        </b-tab>

        <b-tab title="Atende" v-if="exibirUsuariosLivechat">
          <tab-usuarios-chat
            :idConta="conta.id"
            ref="abaUsuariosChat"
          ></tab-usuarios-chat>
        </b-tab>

        <b-tab title="CRM" v-if="recursos.includes('CRM')">
          <tab-usuarios-crm
            :idConta="conta.id"
            ref="abaUsuariosCrm"
          ></tab-usuarios-crm>
        </b-tab>
      </b-tabs>

      <template #modal-footer="{ close }">
        <button type="button" class="btn config-btn-secondary" @click="close()">
          Fechar
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import UsuariosComunicante from "./usuario/UsuariosComunicante";
import UsuariosChat from "./livechat/UsuariosChat";
import UsuariosCrm from "./crm/UsuariosCrm";
import ApiService from "@/core/services/api.service";

export default {
  props: {
    conta: Object,
    variant: {
      type: String,
      default: "light-primary"
    },
    tipoBotao: {
      type: String,
      default: "icone"
    }
  },

  data() {
    return {
      abaSelecionada: 0,
      recursos: []
    };
  },

  components: {
    "tab-usuarios-comunicante": UsuariosComunicante,
    "tab-usuarios-chat": UsuariosChat,
    "tab-usuarios-crm": UsuariosCrm
  },

  computed: {
    botaoDropdown() {
      return this.tipoBotao === "dropdown";
    },

    exibirUsuariosLivechat() {
      return (
        this.conta.existeContaChatwoot == "S" &&
        this.recursos.includes("LIVE_CHAT")
      );
    }
  },

  methods: {
    async abrir() {
      try {
        const response = await ApiService.get(
          `conta/recurso-ativo/${this.conta.id}`
        );
        const recursos = response.data.data;

        this.recursos = recursos.map(function (obj) {
          return obj.rec_codigo;
        });

        this.$refs["mdlUsuariosConta"].show();
      } catch {
        // Sem permissão real para essa conta (ex.: fora dos casos previstos
        // pelo gate do botão) — não abre o modal em vez de deixá-lo vazio
        // após o "Não autorizado".
      }
    },

    // Acionado pela aba Comunicante quando a busca de usuários falha (ex.:
    // 403) — fecha o modal em vez de deixá-lo aberto com a lista vazia.
    fecharPorErro() {
      this.$refs["mdlUsuariosConta"].hide();
    }
  }
};
</script>
